import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Shipping } from "@faire/web--source/slate/icons/foundation/Shipping";
import React from "react";
import { useOrderCanceledBrandNodes } from "./useOrderCanceledBrandNodes";
import { useOrderDeliveredBrandNodes } from "./useOrderDeliveredBrandNodes";
import { useOrderNewBrandNodes } from "./useOrderNewBrandNodes";
import { useOrderShippedBrandNodes } from "./useOrderShippedBrandNodes";
import { useOrderUnfulfilledBrandNodes } from "./useOrderUnfulfilledBrandNodes";
import { useOrderUnknownBrandNodes } from "./useOrderUnknownBrandNodes";
export var useOrdersBrandNodes = function useOrdersBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var orderUnknown = useOrderUnknownBrandNodes();
  var orderNew = useOrderNewBrandNodes();
  var orderUnfulfilled = useOrderUnfulfilledBrandNodes();
  var orderShipped = useOrderShippedBrandNodes();
  var orderDelivered = useOrderDeliveredBrandNodes();
  var orderCanceled = useOrderCanceledBrandNodes();
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    Orders: {
      id: "Orders",
      label: strictLocalize({
        id: "DPqb3A",
        defaultMessage: [{
          "type": 0,
          "value": "Beställningar"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Shipping, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: [
      // unknown state nodes
      "AddOrEditItemsUnknownState", "EditOrderInformationUnknownState", "InternationalOrderSettingsUnknownState", "DamageMissingItemReportUnknownState", "RequestCommissionChangesUnknownState", "CancelOrderUnknownState", "CannotFindAnOrderUnknownState",
      // new state nodes
      "QuestionAboutCustomerNewState", "AddOrEditItemsNewState", "EditOrderInformationNewState", "InternationalOrderSettingsNewState", "RequestCommissionChangesNewState", "InsiderFreeShippingNewState", "SplitOrderNewState", "CancelOrderNewState",
      // unfulfilled state nodes
      "AddOrEditItemsUnfulfilledState", "EditOrderInformationUnfulfilledState", "VatIssueUnfulfilledState", "SplitOrderUnfulfilledState", "CombineOrdersUnfulfilledState", "RequestCommissionChangesUnfulfilledState", "CancelOrderUnfulfilledState",
      // shipped state nodes
      "UpdateTrackingInformationShippedState", "ProblemWithDeliveryShippedState", "PayoutCalculationShippedState", "InvoiceDetailsShippedState", "RequestCommissionChangesShippedState",
      // delivered state nodes
      "DamageMissingItemReportDeliveredState", "PayoutCalculationDeliveredState", "InvoiceDetailsDeliveredState", "ProblemWithDeliveryDeliveredState", "RequestCommissionChangesDeliveredState",
      // canceled state nodes
      "WhyWasThisCanceledCanceledState", "OtherCanceledState"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "n4jo5/",
        defaultMessage: [{
          "type": 0,
          "value": "Problem med beställning"
        }]
      })
    }
  }, orderUnknown), orderNew), orderUnfulfilled), orderShipped), orderDelivered), orderCanceled);
};